/* 🤖 this file was generated by svg-to-ts */
export const iconDashedCircle: {
    name: 'dashed_circle';
    data: string;
} = {
    name: 'dashed_circle',
    data: `<svg xmlns="http://www.w3.org/2000/svg"><circle cx="50%" cy="50%" r="49%" fill="none" stroke="#000" stroke-dasharray="5,5" stroke-width="2"/></svg>`
};
